export default __webpack_public_path__ + "773b3a902286ec9affc75f31b22cfe01.svg";